import React from 'react';

import {ImageExportType} from '../../../util/panelExport';
import {PanelType} from '../../../util/panelTypes';
import {PanelImageExportModal} from '../../PanelImageExportModal';
import {ExportType} from '../types';
import {PanelExportCSV} from './PanelExportCSV';

export const PanelExportModalContainer = ({
  exportType,
  imageExportType,
  panelType,
  unsetExportType,
}: {
  exportType: ExportType | undefined;
  imageExportType: ImageExportType | undefined;
  panelType: PanelType;
  unsetExportType: () => void;
}) => {
  if (exportType == null) {
    return null;
  }

  if (exportType === ExportType.CSV) {
    return <PanelExportCSV open={true} onClose={unsetExportType} />;
  }

  if (exportType === ExportType.Image && imageExportType) {
    return (
      <PanelImageExportModal
        open={true}
        type={imageExportType}
        onClose={unsetExportType}
        panelType={panelType}
      />
    );
  }

  return null;
};
